module.exports = __webpack_public_path__ + "static/media/id-card-icon.d20ca7f3.svg";